import React from "react";
import { Card, Row, Col } from "antd";
import "./CardContent.css";
const { Meta } = Card;

class CardContent extends React.Component {
  render() {
      let imgStyle = {
          objectFit : "cover"
      }
      let cardStyle ={
          
      }
    return (
      <div className="card">
        <div>
          <h1>Berbagai macam pilihan!</h1>
        </div>
        <div>
          <Row gutter={16}>
            <Col span={6}>
              <Card
                hoverable
                size = {"small"}
                style={imgStyle}
                cover={
                  <img
                  style={imgStyle}
                    alt="example"
                    src="https://images.pexels.com/photos/2983661/pexels-photo-2983661.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                  />
                }
              >
                <Meta
                  title="Sore sore sama pacar"
                  description="www.instagram.com"
                />
              </Card>
            </Col>
            <Col span={6} style = {imgStyle}>
              <Card
                hoverable
                size = {"small"}
                style={imgStyle}
                cover={
                  <img style={imgStyle}
                    alt="example"
                    src="https://images.pexels.com/photos/1122410/pexels-photo-1122410.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                  />
                }
              >
                <Meta
                  title="Jelajah desa"
                  description="www.instagram.com"
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card
                hoverable
                size = {"small"}
                style={imgStyle}
                cover={
                  <img style={imgStyle}
                    alt="example"
                    src="https://images.pexels.com/photos/2549355/pexels-photo-2549355.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                  />
                }
              >
                <Meta
                  title="Kota kota"
                  description="www.instagram.com"
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card
                hoverable
                size = {"small"}
                style={imgStyle}
                cover={
                  <img style={imgStyle}
                    alt="example"
                    src="https://images.pexels.com/photos/876611/pexels-photo-876611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                  />
                }
              >
                <Meta
                
                  title="Nongkrong cantiq"
                  description="www.instagram.com"
                />
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default CardContent;
